(function () {
  function parseSkuText(text) {
    if (!text) return [];
    return String(text)
      .split(/[,，;；\n\r]+/)
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
  }

  function whenSwiperReady(cb) {
    if (typeof Swiper !== 'undefined') {
      cb();
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        cb();
      } else if (tries >= 40) {
        clearInterval(timer);
      }
    }, 50);
  }

  function initVernalRecfg(root) {
    var sectionId = root.dataset.sectionId;
    if (!sectionId) return;

    var mainSwiper = null;
    var thumbSwiper = null;
    var activeIndex = 0;

    var applyBtn = root.querySelector('.vernal-recfg__apply');
    var tabs = root.querySelectorAll('[data-vernal-recfg-tab]');
    var sets = Array.from(root.querySelectorAll('[data-vernal-recfg-set]'));
    var applyLabel =
      (applyBtn && applyBtn.getAttribute('data-apply-label')) ||
      (applyBtn && applyBtn.textContent ? applyBtn.textContent.trim() : 'Apply this Setup');
    var outOfStockLabel =
      (applyBtn && applyBtn.getAttribute('data-out-of-stock-label')) || 'Out of Stock';

    if (!sets.length) return;

    function findDiyRoot() {
      var tid = root.getAttribute('data-diy-target-id');
      if (tid) {
        var byId = document.getElementById(tid);
        if (byId && byId.matches('[data-office-layout-configurator]')) return byId;
        return null;
      }
      return document.querySelector('[data-office-layout-configurator]');
    }

    function areActiveSkusAvailable(setEl) {
      var diyRoot = findDiyRoot();
      if (!diyRoot || typeof diyRoot._olcCheckPresetSkusAvailable !== 'function') return true;
      var skuText = getActiveSceneSkuText(setEl);
      var skus = parseSkuText(skuText);
      if (!skus.length) return true;
      return diyRoot._olcCheckPresetSkusAvailable(skus).available;
    }

    function updateApplyButtonState() {
      if (!applyBtn) return;
      var setEl = getSetEl(activeIndex);
      if (!setEl) return;
      var available = areActiveSkusAvailable(setEl);
      if (available) {
        applyBtn.disabled = false;
        applyBtn.classList.remove('is-disabled');
        applyBtn.textContent = applyLabel;
        applyBtn.setAttribute('aria-disabled', 'false');
      } else {
        applyBtn.disabled = true;
        applyBtn.classList.add('is-disabled');
        applyBtn.textContent = outOfStockLabel;
        applyBtn.setAttribute('aria-disabled', 'true');
      }
    }

    function parseSceneSkuLists(setEl) {
      if (!setEl) return [];
      var raw = setEl.getAttribute('data-scene-sku-lists');
      if (!raw) return [];
      try {
        var parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }

    function getActiveSceneSkuText(setEl) {
      if (!setEl) return '';
      var lists = parseSceneSkuLists(setEl);
      if (lists.length && mainSwiper != null) {
        var ri = mainSwiper.realIndex;
        if (!isNaN(ri) && ri >= 0 && ri < lists.length) {
          var sceneText = lists[ri];
          if (sceneText != null && String(sceneText).trim()) {
            return String(sceneText);
          }
        }
      }
      return setEl.getAttribute('data-sku-text') || '';
    }

    function getSetEl(ix) {
      if (ix < 0 || ix >= sets.length) return null;
      return sets[ix];
    }

    function destroySwipers() {
      if (mainSwiper) {
        mainSwiper.destroy(true, true);
        mainSwiper = null;
      }
      if (thumbSwiper) {
        thumbSwiper.destroy(true, true);
        thumbSwiper = null;
      }
    }

    function bindThumbNavButtons(setEl) {
      if (!setEl) return;
      if (setEl._recfgThumbNavCleanup) {
        setEl._recfgThumbNavCleanup();
        setEl._recfgThumbNavCleanup = null;
      }
      var prevBtn = setEl.querySelector('[data-recfg-thumbs-prev]');
      var nextBtn = setEl.querySelector('[data-recfg-thumbs-next]');
      if (!prevBtn && !nextBtn) return;

      function onPrev(e) {
        if (e) e.preventDefault();
        if (mainSwiper && typeof mainSwiper.slidePrev === 'function') mainSwiper.slidePrev();
      }
      function onNext(e) {
        if (e) e.preventDefault();
        if (mainSwiper && typeof mainSwiper.slideNext === 'function') mainSwiper.slideNext();
      }

      if (prevBtn) prevBtn.addEventListener('click', onPrev);
      if (nextBtn) nextBtn.addEventListener('click', onNext);

      setEl._recfgThumbNavCleanup = function () {
        if (prevBtn) prevBtn.removeEventListener('click', onPrev);
        if (nextBtn) nextBtn.removeEventListener('click', onNext);
      };
    }

    function initSwipersForSet(setEl) {
      if (!setEl) return;
      var mainEl = setEl.querySelector('.vernal-recfg__main.swiper');
      var thumbsEl = setEl.querySelector('.vernal-recfg__thumbs.swiper');
      if (!mainEl || !thumbsEl) return;

      var sceneCount = parseInt(setEl.getAttribute('data-scene-count'), 10);
      if (isNaN(sceneCount)) sceneCount = 0;
      var canCarousel = sceneCount >= 2;

      whenSwiperReady(function () {
        // Wait one frame after unhide so Swiper can measure widths correctly.
        requestAnimationFrame(function () {
          // 缩略图条不参与 loop：与主图 loop + thumbs 联动时，2 张图场景下会导致「下一页」无法循环。
          thumbSwiper = new Swiper(thumbsEl, {
            spaceBetween: 8,
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            watchOverflow: !canCarousel,
            slideToClickedSlide: true,
            freeMode: true,
            loop: false,
          });

          mainSwiper = new Swiper(mainEl, {
            spaceBetween: 0,
            watchOverflow: !canCarousel,
            loop: false,
            rewind: canCarousel,
            navigation: {
              nextEl: setEl.querySelector('[data-recfg-main-next]'),
              prevEl: setEl.querySelector('[data-recfg-main-prev]'),
            },
            thumbs: { swiper: thumbSwiper },
          });

          bindThumbNavButtons(setEl);

          mainSwiper.on('slideChange', updateApplyButtonState);

          // Ensure navigation state and widths are up to date.
          if (thumbSwiper && typeof thumbSwiper.update === 'function') thumbSwiper.update();
          if (mainSwiper && typeof mainSwiper.update === 'function') mainSwiper.update();
          updateApplyButtonState();
        });
      });
    }

    function renderSet(index) {
      activeIndex = index;
      destroySwipers();
      sets.forEach(function (el, i) {
        var on = i === index;
        el.hidden = !on;
        el.classList.toggle('is-active', on);
      });
      var setEl = getSetEl(index);
      if (!setEl) return;
      initSwipersForSet(setEl);
      updateApplyButtonState();
    }

    function setActiveTab(ix) {
      tabs.forEach(function (btn, i) {
        var on = i === ix;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var ix = parseInt(btn.getAttribute('data-vernal-recfg-tab'), 10);
        if (isNaN(ix)) return;
        setActiveTab(ix);
        renderSet(ix);
      });
    });

    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        if (applyBtn.disabled || applyBtn.classList.contains('is-disabled')) return;
        var setEl = getSetEl(activeIndex);
        if (!setEl) return;
        var skuText = getActiveSceneSkuText(setEl);
        var skus = parseSkuText(skuText);
        if (!skus.length) {
          if (window.BMessage && typeof window.BMessage.warning === 'function') {
            window.BMessage.warning({
              content: 'Please configure a cabinet list for this scene or the default list for this set.',
            });
          }
          return;
        }
        var detail = {
          skus: skus,
          scroll: true,
        };
        var tid = root.getAttribute('data-diy-target-id');
        if (tid) detail.targetId = tid;
        document.dispatchEvent(
          new CustomEvent('office-layout-configurator:apply-preset', {
            bubbles: true,
            detail: detail,
          })
        );
      });
    }

    setActiveTab(0);
    renderSet(0);

    document.addEventListener('office-layout-configurator:ready', updateApplyButtonState);
    var diyRoot = findDiyRoot();
    if (diyRoot && typeof diyRoot._olcCheckPresetSkusAvailable === 'function') {
      updateApplyButtonState();
    }
  }

  function mountAll() {
    document.querySelectorAll('[data-vernal-recfg]').forEach(initVernalRecfg);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var r = ev.target && ev.target.querySelector && ev.target.querySelector('[data-vernal-recfg]');
    if (r) initVernalRecfg(r);
  });
})();
